import Layout from "./components/Layout";
import OptionItem from "./components/OptionItem";
import OptionComponent from "./components/OptionList";

OptionComponent.Item = OptionItem;
OptionComponent.Layout = Layout;

export default OptionComponent;
